export default __webpack_public_path__ + "static/media/cpu1.e6001bcf.svg";